<script>

export default {
  name: 'ReportingApp',

  async created() {
    const { advertiserId, campaignId, group } = this.$route.params;
    const redirectPath = campaignId ? `${process.env.VUE_APP_REPORTING_URL}/reports/aid/${advertiserId}/cid/${campaignId}`
      : `${process.env.VUE_APP_REPORTING_URL}/reports/aid/${advertiserId}/group/${encodeURIComponent(group)}`;
    window.location.href = redirectPath;
  },
};

</script>
